import React, { useState, useEffect, useRef, useCallback, ReactNode } from "react"
//import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
//import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
//import { createTheme, ThemeProvider } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
//import Button from '@mui/material/Button';
//import Stack from '@mui/material/Stack';
import { useAuthProfile } from "../../app/hooks"
//import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import { IconButton, ListItemIcon } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import { useLazyGetSearchResultsQuery, useGetFAQsQuery, useGetRecentSearchesQuery, useLazyGetSearchAutocompleteQuery } from '../../features/resourcesSlice'
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Markdown from 'react-markdown'

import Tabs from '@mui/material/Tabs';
import Tab, { TabProps } from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { Alert, Button, Box, Stack, Skeleton, ListItemButton, ListItem, ListItemText, Typography } from '@mui/material';
import  LoadingButton  from '@mui/material/Button'
import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemButton from '@mui/material/ListItemButton';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';
import { useSearchParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Snackbar from '@mui/material/Snackbar';
import Grid from '@mui/material/Grid';
//import Badge from '@mui/material/Badge';
//import PersonIcon from '@mui/icons-material/Person';
import { debounce } from '@mui/material/utils';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { StartChat } from "../markers/MMMarkers";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { MarkdownEmbeddedImageRenderer } from '../../app/components/blob-url-from-Base64'
import { Padding } from "@mui/icons-material";
import { PerplexitySearchResultsWithNavigation } from "./ResourceResults";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircleIcon from '@mui/icons-material/Circle';
import { RenderStudies } from "./RenderStudies";
import { coonditionContext, Condition, capitalizeWords } from '../../index'
import { useAuth } from "react-oidc-context";

import { cleanText } from './resourceUtils';
export { cleanText };

const ResourceTab: React.FC<TabProps> = (props) => (
  <Tab
    disableRipple
    sx={{
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 6,
      minHeight: 36,
      px: 2,
      py: 0.5,
      mx: 0.5,
      fontSize: '0.82rem',
      color: '#555',
      border: '1px solid #E0DEFF',
      backgroundColor: 'rgba(255,255,255,0.7)',
      transition: 'all 0.15s ease',
      '&:hover': {
        backgroundColor: '#EDE9FF',
        borderColor: '#C5BEFF',
        color: '#656EFF',
      },
      '&.Mui-selected': {
        color: 'white',
        backgroundColor: '#656EFF',
        borderColor: '#656EFF',
        boxShadow: '0 2px 8px rgba(101,110,255,0.25)',
      },
    }}
    {...props}
  />
);

interface SearchText { cleanText: string, validateText: string }
const knowledgeConnectDisclamer = 'Knowledge Connect is provided for informational purposes only and not a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.'
export const ResourceLanding: React.FC = () => {
  // Initialization
  //const dispatch = useDispatch()
  const { authStatus, profile, isLoading: isAuthProfileLoading, isSuccess, isError, error, /*userAttributesStateStatus */ } = useAuthProfile()
  //const { data: faqResult, isLoading: faqLoading } = useGetFAQsQuery()
  //const { data: recentSearchResult, isLoading: recentSearchResultLoading } = useGetRecentSearchesQuery()
  const [searchText, setSearchText] = useState<SearchText>({ cleanText: '', validateText: '' })
  //const [resultText, setResultText] = useState('')
  //const [getSearch, { data: searchResult, isLoading: isSearchLoading, isSuccess: searchSuccess, isError: searchError, isUninitialized: isSearchUninitialized }] = useLazyGetSearchResultsQuery()
  const [getAutocomplete, { data: autocompleteResult, isLoading: autocompleteLoading, isSuccess: autocompleteSuccess, isError: autocompleteError }] = useLazyGetSearchAutocompleteQuery()
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  //const [openResultPage, setOpenResultPage] = useState(false)
  //const [triggerSearch, setTriggerSearch] = useState(false)
  //const [faqTab, setFaqTab] = React.useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showAutocomplete, setShowAutocomplete] = useState(false)
  //const hasSearchedFromURL = useRef(false);
  const navigate = useNavigate()

  let searchPage = searchParams.get("search")
  const searchId = searchParams.get("searchId")
  const clinicalTrial = searchParams.get("clinicalTrial")
  const category = searchParams.get('category');

  useEffect(() => {
    if (category !== 'Paid_Studies') {
      if (searchPage) {
        setSearchText(cleanText(searchPage));
      }
    } else {
      setSearchText({ cleanText: '', validateText: '' });
    }
  }, [searchPage])


  // Root function to handle dispatch of search
  function handleSubmit(e: any) {
    if (e)
      e.preventDefault();

    if (searchText.validateText.length === 0 || isSuccess === false) {
      return
    }
    // setLoading(true)
    // //setOpenResultPage(true)
    // //setSearchParams({ search: searchText.cleanText }, { replace: false })

    // setTimeout(() => {
    //   setLoading(false);
    // }, 1000);

    //getSearch({ query: searchText.cleanText, profile_id: profile.id }, true)// preferCacheValue: false // { forceRefetch: true })
    const queryParams = new URLSearchParams({
      search: searchText.cleanText,
      //category: category ?? ''
    });
    navigate(`/Resources?${queryParams.toString()}`);
    //setResultText(searchText.cleanText)
  }



  // manage debounce logic
  const debouncedSearch = React.useRef(
    debounce(async (text: string) => {
      getAutocomplete(text);
    }, 300)
  ).current;

  // Cancels debounce
  React.useEffect(() => {
    return () => {
      //debouncedSearch.cancel();
      debouncedSearch.clear(); // using MUI's debounce
    };
  }, [debouncedSearch]);

  // Handle FAQ search
  function handleFAQSearch(e: any, text: string) {
    document.getElementById('resource_top')?.scrollIntoView({ behavior: 'smooth' })
    // if (!loading) {
    //   setSearchText(cleanText(text))
    //   setTriggerSearch(true)
    //   setOpenResultPage(true)
    //   setShowAutocomplete(false)
    // }
    const queryParams = new URLSearchParams({
      search: text,
      category: category ?? ''
    });
    navigate(`/Resources?${queryParams.toString()}`);
  }

  //console.log(searchResult?.result )
  // Rendering
  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  const auth = useAuth()
  return (
    <Container>
      <div id="resource_top"></div>
      <Paper elevation={0} sx={{
        mt: 4,
        mb: 4,
        p: { xs: 2, sm: 4 },
        borderRadius: 4,
        backgroundColor: 'rgba(244, 240, 255, 0.55)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid rgba(164, 142, 233, 0.18)',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
      }}>
      <Stack sx={{ pt: 4, pb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', justifyItems: 'center', }} gap={2} >
        <Typography variant="h5">Knowledge Connect</Typography>
        {authStatus !== 'authenticated' &&
          <>
            <Link sx={{ cursor: 'pointer' }} variant="body1" onClick={() => navigate('/signin')}>
              Sign in or create a free account to use search
            </Link>
            <Typography color="primary" variant="body1">
              {false && <>{condition} Patient Guide below is available to everyone</>}
            </Typography>
          </>
        }

        <Paper
          elevation={0}
          sx={{ display: 'flex', flexGrow: 2, width: '100%', backgroundColor: '#F4F4F8', borderRadius: 8, pl: 2, justifyContent: 'space-between' }}
          component="form"
          onSubmit={handleSubmit}
        >
          {/*(category === '7') && <Typography variant="subtitle1" sx={{ padding: '10px', fontWeight: 'bold', pt: 1, color: '#62648F' }}>{searchText.cleanText}</Typography>*/}
          {/*(category !== '7') && */}<>
            <InputBase name="search" sx={{ flexGrow: 10 }} disabled={isSearchLoading || authStatus !== "authenticated"}
              placeholder="Ask any question"
              value={searchText.cleanText}
              inputProps={{ autoComplete: 'off' }}
              onChange={(e) => {
                if (e.target.value.replace(/[^a-zA-Z 0-9]+/g, '').trim().length > 0) {
                  setShowAutocomplete(true)
                  //debouncedSearch(e.target.value)
                  debouncedSearch(e.target.value)
                } else {
                  setShowAutocomplete(false)
                }
                setSearchText(cleanText(e.target.value));
                //setSearchParams({ name: 'Alice' }, { replace: false });

              }}
            />
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search" >
              <ArrowCircleRightRoundedIcon sx={{ color: '#656EFF' }} />
            </IconButton>
          </>

        </Paper>
        <Typography variant="caption" sx={{ fontWeight: '500', color: 'gray', marginBottom: 1 }}>{knowledgeConnectDisclamer}</Typography>
        {(autocompleteResult && showAutocomplete && autocompleteResult?.length > 0) &&
          <Box sx={{ width: '100%', backgroundColor: 'white', border: 1, borderColor: '#E0E0E0', maxHeight: '225px', overflow: 'auto' }}>
            <List>
              {autocompleteResult.map((row: any) => (
                <ListItem disablePadding key={row.search_term} >
                  <ListItemButton onClick={(e) => { handleFAQSearch(e, row.search_term) }} >
                    <ListItemText
                      primary={row.search_term}
                      primaryTypographyProps={{
                        fontSize: { xs: '0.75rem', sm: '0.95rem', md: '1rem' },
                        noWrap: true, // Ensures the text is limited to a single line
                        sx: {
                          overflow: 'hidden',       // Hide any overflowed text
                          textOverflow: 'ellipsis', // Add ellipses for overflowed text
                          whiteSpace: 'nowrap',     // Prevent text wrapping
                        },
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
        }
        {(searchPage || searchId || clinicalTrial) ? <PerplexitySearchResultsWithNavigation
          setQueryText={(query) => {
            //searchPage = query
            setSearchText(cleanText(query));
          }}
          setLoading={(isLoading: boolean) => setIsSearchLoading(isLoading)} /> :
          <PatientGuide handleFAQ={handleFAQSearch} />}
      </Stack>
      </Paper>
    </Container>
  )
}


// Component helpers
const ResourceTabs = styled(Tabs)({
  borderBottom: 0,
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const FadingTabsWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const check = useCallback(() => {
    const el = ref.current?.querySelector('.MuiTabs-scroller') as HTMLElement | null;
    if (!el) return;
    const sl = el.scrollLeft;
    const maxScroll = el.scrollWidth - el.clientWidth;
    setCanScrollLeft(sl > 2);
    setCanScrollRight(maxScroll - sl > 2);
  }, []);

  useEffect(() => {
    const el = ref.current?.querySelector('.MuiTabs-scroller') as HTMLElement | null;
    if (!el) return;
    check();
    el.addEventListener('scroll', check, { passive: true });
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => { el.removeEventListener('scroll', check); ro.disconnect(); };
  }, [check]);

  const maskParts: string[] = [];
  if (canScrollLeft) maskParts.push('transparent 0%, black 60px');
  else maskParts.push('black 0%');
  if (canScrollRight) maskParts.push('black calc(100% - 60px), transparent 100%');
  else maskParts.push('black 100%');
  const mask = `linear-gradient(to right, ${maskParts.join(', ')})`;

  return (
    <Box ref={ref} sx={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', py: 1, maxWidth: '100%',
      '& .MuiTabs-scroller': {
        maskImage: mask,
        WebkitMaskImage: mask,
      },
    }}>
      {children}
    </Box>
  );
};
interface ResourceTabProps {
  children: ReactNode; // Define children as ReactNode
  // Include any other props you might need here
}


export const PatientGuide: React.FC<{ handleFAQ: (e: any, text: string) => void }> = ({ handleFAQ }) => {
  const { data: faqResult, isSuccess: isFaqSuccess, isLoading: isFaqLoading, isError: isFaqError, refetch } = useGetFAQsQuery()
  const [faqTabString, setFaqTabString] = React.useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  // Access the current location (which contains the query string)
  const location = useLocation();
  // Use URLSearchParams to parse the query string
  const queryParams = new URLSearchParams(location.search);
  // Example: Get a specific query parameter (e.g., `?name=John`)
  const category = queryParams.get('category');


  useEffect(() => {
    if (!isFaqError) return;
    const interval = setInterval(() => refetch(), 5000)//* 60 * 1000);
    return () => clearInterval(interval);
  }, [isFaqError]);

  useEffect(() => {
    //setFaqTab(Number(category ?? 0))
    if (isFaqSuccess && faqResult.length > 0) {
      setFaqTabString(category ?? faqResult[0].category)//.replaceAll(" ", '_'))
    }
  }, [category, faqTabString, setFaqTabString, isFaqSuccess])

  // Handle faq tab change
  const handleChange = (event: any, newTab: number) => {
    //event.target[0]
    const newTabLabel = faqResult[newTab].category//.replaceAll(" ", '_')
    setFaqTabString(newTabLabel)//newTab);
    setSearchParams({ category: newTabLabel }, { replace: false })
  };

  const { condition } = React.useContext<Condition>(coonditionContext);
  const GetFaqByString: (labelStr: string) => { index: number, faq: any } | undefined = (labelStr) => {
    //const ret = faqResult.find( (row: any) => row.category.replaceAll(" ", '_') === labelStr )
    const retIndex = faqResult.findIndex((row: any) => row.category === labelStr)//.replaceAll(" ", '_') === decodeURIComponent(labelStr) )    
    return retIndex !== -1 ? { index: retIndex, faq: faqResult[retIndex] } : undefined
  }


  return (<>
    {(isFaqSuccess && faqTabString) &&
      <>
        <Typography sx={{ fontWeight: 'bold', fontSize: { xs: '16px', sm: '18px', md: '20px' } }}>{condition} Patient Guide</Typography>
        <FadingTabsWrapper>
          <ResourceTabs
            value={GetFaqByString(faqTabString)?.index}
            variant="scrollable"
            onChange={(event: any, newTab: number) => handleChange(event, newTab)}
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            {faqResult.map((row: any) => (
              <ResourceTab label={row.category} key={row.category} />
            ))}
          </ResourceTabs>
        </FadingTabsWrapper>
        {category === 'Paid Studies' ? <RenderStudies questionsData={GetFaqByString('Paid Studies')?.faq} /> :
          <List sx={{
            width: '100%',
            borderRadius: 3,
            border: '1px solid rgba(164, 142, 233, 0.18)',
            backgroundColor: 'rgba(255,255,255,0.85)',
            boxShadow: '0 2px 12px rgba(101, 110, 255, 0.06)',
            overflow: 'hidden',
            p: 0,
          }}>
            {GetFaqByString(faqTabString)?.faq.questions.map((row: any, idx: number) => (
              <ListItem disablePadding key={"item_" + faqTabString.toString() + "_" + row}
                sx={{
                  backgroundColor: idx % 2 === 1 ? 'rgba(101, 110, 255, 0.025)' : 'transparent',
                }}
              >
                <Stack direction="column" sx={{ width: '100%' }}>
                  <ListItemButton key={"button_" + faqTabString.toString() + "_" + row} onClick={(e) => { handleFAQ(e, row) }} sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    py: { xs: 1.5, sm: 1.8 },
                    px: { xs: 2, sm: 2.5 },
                    borderLeft: '3px solid transparent',
                    transition: 'all 0.15s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(101, 110, 255, 0.06)',
                      borderLeft: '3px solid #656EFF',
                    },
                    '&:hover .faq-arrow': {
                      color: '#656EFF',
                      transform: 'translate(1px, -1px)',
                    },
                  }}>
                    <ListItemText
                      primary={row}
                      key={"text_" + faqTabString.toString() + "_" + row}
                      primaryTypographyProps={{
                        fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                        fontWeight: 500,
                        color: '#2a2a3e',
                      }}
                    />
                    <ArrowOutwardIcon className="faq-arrow" sx={{ color: '#aaa', fontSize: 'medium', transition: 'all 0.15s ease', ml: 1, flexShrink: 0 }} />
                  </ListItemButton>
                  <Divider sx={{ width: '95%', margin: 'auto', borderColor: 'rgba(164, 142, 233, 0.12)' }} key={faqTabString.toString() + "_" + row} />
                </Stack>
              </ListItem>

            ))}
          </List>
        }
      </>
    }
    {(isFaqLoading || isFaqError) &&
      <>
        <Skeleton animation="wave" variant="rectangular" width='50%' height={60} sx={{ border: 1, borderRadius: 8, borderColor: '#E0E0E0' }} />
        <Skeleton animation="wave" variant="rectangular" width='100%' height={400} />
      </>
    }
    {/* {isFaqError &&
      <Alert severity={'error'}>'Oops... Sorry, there was a problem initialing Patient Connect. Please try again later</Alert>
    } */}
  </>)
}

export { PerplexitySearchResultsWithNavigation };
